/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { MenuItem, Select, TextField } from "@mui/material";
import { useUpdateComponent } from "cms/components/hooks/use-update-component";
import LabelledField from "components/labelled-field";
import { useTranslation } from "react-i18next";
import { isArrayNotEmpty } from "utils/empty-exists";
import { useFeatureFlag } from "cms/features/use-feature-flag";
// import Config from 'data/config'

const selectionOptions = [
    { name: "Heading 1", value: "heading1" },
    { name: "Heading 2", value: "heading2" },
    { name: "Heading 3", value: "heading3" },
    { name: "Heading 4", value: "heading4" },
    // { name: 'Heading 5', value: 'heading5' },
    // { name: 'Heading 6', value: 'heading6' },
];
const cssStyle = {
    background: "#FFFFFF",
    borderRadius: "4px",
    border: "1px solid #DFDFDF",
    // color: "#000000",
    color: "#CECECE",
    fontFamily: "inherit",
    fontSize: ".875rem",
    fontWeight: 500,
    lineHeight: 1.0,
    height: "24px",
    width: "22px",
    margin: "none",
    padding: "1px 1px",
    position: "relative",
    bottom: "-6px",
    transition: "all .2s cubic-bezier(.65,.05,.36,1)",
};

const HeadingComponentEditor = () => {
    
    const { t } = useTranslation();
    const { component, update } = useUpdateComponent();
    const value = component?.value;
    const style = component?.style;
    const color = component?.color;
    const disabled = false;
    const colorFeatureEnabled = useFeatureFlag("feature_rich_text_colour");
        
    const onChangeValue = (event) => {
        const value = event.target.value;
        update("value", value);
    };
    
    const onChangeStyle = (event) => {
        const style = event.target.value;
        update("style", style);
    };

    const onChangeColor = (event) => {
        const style = event.target.value;
        update("color", style);
    };

    return (
        <div className='simplicity-editor-frame'>
            <LabelledField label={t("commons.headingText")} className='labelField'>
                <TextField
                    fullWidth={true}
                    placeholder='Add a single line of text'
                    value={value}
                    onChange={onChangeValue}
                />
            </LabelledField>
            <LabelledField label={t("commons.displayStyle")} className='labelField'>
                {isArrayNotEmpty(selectionOptions) &&
                    <Select
                        labelId='heading_select'
                        id='heading_select'
                        value={style}
                        onChange={onChangeStyle}
                        style={{ width: "100%" }}
                    >
                        {isArrayNotEmpty(selectionOptions) &&
                            selectionOptions.map((item, index) => (
                                <MenuItem key={index} value={item.value}>
                                    {item.name}
                                </MenuItem>
                            ))}
                    </Select>
                }
            </LabelledField>
            {colorFeatureEnabled &&
                <LabelledField label={t("commons.colour")} className='labelField'>
                    <input
                        type="color"
                        onInput={onChangeColor}
                        value={color}
                        data-testid="setColor"
                        disabled={disabled}
                        style={cssStyle}
                    />
                </LabelledField>
            }                
        </div>
    );
};

HeadingComponentEditor.displayName = "HeadingComponentEditor";
export { HeadingComponentEditor };
